import { endpoints } from '@/config';
import api from './api';
import { fromLegacy, toLegacy } from './migration/filters';

let last;
export function getLast() {
  return last;
}

export function getFilters() {
  const endpoint = endpoints.filters;
  return api
    .get(endpoint)
    .then((response) => {
      last = response.data.map(fromLegacy);
      return response.data.map(fromLegacy);
    })
    .catch((error) => Promise.reject(error.response?.data));
}

export function createFilter(filter) {
  last = undefined;
  if (!filter) {
    throw new Error('Cannot create empty filter.');
  }
  const create = toLegacy(filter);
  delete create.$id;
  const endpoint = endpoints.filters;
  return api.post(endpoint, create)
    .then((response) => fromLegacy({ ...create, ...response.data }))
    .catch((error) => Promise.reject(error.response?.data));
}

export function updateFilter(filter) {
  last = undefined;
  if (!filter.id) {
    throw new Error('Cannot update filter without id.');
  }
  const { $id, ...update } = toLegacy(filter);
  const onlyId = $id.replace('/savedSearches/', '');
  const endpoint = `${endpoints.filters}/${onlyId}`;
  return api.put(endpoint, update)
    .then((response) => fromLegacy({ ...filter, ...response.data }))
    .catch((error) => Promise.reject(error.response?.data));
}

export function deleteFilter(filter) {
  last = undefined;
  if (!filter.id) {
    throw new Error('Cannot delete filter without id.');
  }
  const { $id } = toLegacy(filter);
  const onlyId = $id.replace('/savedSearches/', '');
  const endpoint = `${endpoints.filters}/${onlyId}`;
  return api.delete(endpoint)
    .catch((error) => Promise.reject(error.response?.data));
}
